import type { Nullable } from '@enmon/commons';

// Parses a sort string in the format "field:order" into an object { field: order }
export const parseSort = (sortString?: Nullable<string>) => {
  if (!sortString) return {};

  const [field, order] = sortString.split(':');
  return { [field]: order };
};
